import { Api } from "./Api";

export default {
    index() {
        return Api.get(`/v1/management/permissions`);
    },
    show(permission_id) {
        return Api.get(`/v1/management/permissions/${permission_id}`);
    },
    store(obj) {
        return Api.post(`/v1/management/permissions`, obj);
    },
    update(permission_id, obj) {
        return Api.put(`/v1/management/permissions/${permission_id}`, obj);
    },
    delete(permission_id) {
        return Api.delete(`/v1/management/permissions/${permission_id}`);
    },
}